import Vue from 'vue';
import VueRouter from  'vue-router';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home'
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../components/LoginForm.vue')
	},
	{
		path: '/localityStandard',
		component: () => import('../components/LocalityStandard.vue')
	},
	{
		path: '/localityRules',
		component: () => import('../components/LocalityRules.vue')
	},
	{
		path: '/transportStandardPlace',
		component: () => import('../components/TransportStandardPlace.vue')
	},
	{
		path: '/transportRulesPlace',
		component: () => import('../components/TransportRulesPlace.vue')
	},
	{
		path: '/discountStandard',
		component: () => import('../components/DiscountStandard.vue')
	},
	{
		path: '/discountRules',
		component: () => import('../components/DiscountRules.vue')
	},
	{
		path: '/boardTypeStandard',
		component: () => import('../components/BoardTypeStandard.vue')
	},
	{
		path: '/boardTypeRules',
		component: () => import('../components/BoardTypeRules.vue')
	},
	{
		path: '/tourTypeStandard',
		component: () => import('../components/TourTypeStandard.vue')
	},
	{
		path: '/tourTypeRules',
		component: () => import('../components/TourTypeRules.vue')
	},
	{
		path: '/tagTypeStandard',
		component: () => import('../components/TagTypeStandard.vue')
	},
	{
		path: '/tagStandard',
		component: () => import('../components/TagStandard.vue')
	},
	{
		path: '/tagRules',
		component: () => import('../components/TagRules.vue')
	},
	{
		path: '/tours',
		component: () => import('../components/ToursManagement.vue')
	}
];

const router = new VueRouter({
  mode: 'history',
  routes
});

// Logged session checker
router.beforeEach((to, _, next) => {
    const isAuthenticated = sessionStorage.getItem('is_auth') === 'true';
    if (to.name !== 'login' && !isAuthenticated) {
        next({ name: 'login' });
    } else if (to.name === 'login' && isAuthenticated) {
        next({ name: 'home' });
    } else {
        next();
    }
});

export default router;